import { memo } from 'react';
import { Box, CircularProgress } from '@mui/material';

function LoadingOverlay() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <CircularProgress />
    </Box>
  );
}

export default memo(LoadingOverlay);
